var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-active-curve flex-center"},[_c('div',{staticClass:"curve-wrp"},[_c('div',{staticStyle:{"height":"15px","width":"100%"},attrs:{"id":_vm.chartId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }